import { Link } from 'react-router-dom';
import { getSellerFulfillmentOptions } from '../utils/businessOrderFulfillment';

const ACTION_LABELS = {
  Processing: 'Start packing',
  Packed: 'Mark packed',
  'Ready for Dispatch': 'Make ready for pickup',
  Cancelled: 'Cancel before pickup',
};

export default function OrderFulfillmentActions({ order, onChange }) {
  const actions = order?.canEditOrderStatus ? getSellerFulfillmentOptions(order)
    .filter(status => status !== order.status && ACTION_LABELS[status]) : [];
  return <div className="flex flex-wrap gap-2">
    {actions.map(status => <button key={status} type="button" onClick={() => onChange(order.id, status)}
      className={`min-h-11 rounded-xl border px-3 text-xs font-semibold ${status === 'Cancelled' ? 'border-neutral-300 text-neutral-700 dark:border-neutral-700 dark:text-neutral-300' : 'business-primary-action border-accent bg-accent text-on-accent'}`}>
      {ACTION_LABELS[status]}
    </button>)}
    {order?.sellerFulfillmentStatus && <Link to={`/business/delivery?view=parcels&orderId=${order.id}`} className="inline-flex min-h-11 items-center text-xs font-semibold text-emerald-700 underline dark:text-emerald-300">View delivery details</Link>}
  </div>;
}
